import React from 'react';
import { useCookies } from 'react-cookie';
import { COOKIE_SETTINGS, CookiePreferencesTrigger } from 'venn-components';
import AuthenticationFooterAttribution from './AuthenticationFooterAttribution';
import isNil from 'lodash/isNil';

export const AuthenticationFooter = () => {
  // Ensure we only render cookie links for EU-users who have cookie preferences set
  const [cookies] = useCookies([COOKIE_SETTINGS]);
  const showCookieFooter = !isNil(cookies[COOKIE_SETTINGS]);
  return (
    <footer className="mt-[150px] py-[56px] px-[60px] bg-venn-grey-90 transform-gpu z-front relative print:hidden">
      {showCookieFooter ? (
        <div className="flex flex-col justify-end items-end w-full">
          <nav>
            <ul className="float-right list-none p-0 m-0 [&_li]:inline-block [&_li]:ml-2.5 h-4">
              <CookiePreferencesTrigger />
            </ul>
          </nav>
        </div>
      ) : null}
      <div className="my-0 mx-auto">
        <AuthenticationFooterAttribution className="pt-2.5 text-venn-white" />
      </div>
    </footer>
  );
};
